"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotchedCorner = exports.NotchedCornerPosition = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const hooks_1 = require("../hooks");
var NotchedCornerPosition;
(function (NotchedCornerPosition) {
    NotchedCornerPosition["TopLeft"] = "TopLeft";
    NotchedCornerPosition["TopRight"] = "TopRight";
    NotchedCornerPosition["BottomLeft"] = "BottomLeft";
    NotchedCornerPosition["BottomRight"] = "BottomRight";
})(NotchedCornerPosition = exports.NotchedCornerPosition || (exports.NotchedCornerPosition = {}));
function getNotchedPolygonPoints(size, position) {
    switch (position) {
        case NotchedCornerPosition.TopLeft: {
            return `0 0 0 ${size} ${size} 0`;
        }
        case NotchedCornerPosition.TopRight: {
            return `0 0 ${size} ${size} ${size} 0`;
        }
        case NotchedCornerPosition.BottomLeft: {
            return `0 0 ${size} ${size} 0 ${size}`;
        }
        case NotchedCornerPosition.BottomRight: {
            return `0 ${size} ${size} 0 ${size} ${size}`;
        }
    }
}
function getNotchedCornerPositionProps(position) {
    switch (position) {
        case NotchedCornerPosition.TopLeft: {
            return {
                top: -0.2032,
                left: 0,
            };
        }
        case NotchedCornerPosition.TopRight: {
            return {
                top: 0,
                right: 0,
            };
        }
        case NotchedCornerPosition.BottomLeft: {
            return {
                bottom: 0,
                left: 0,
            };
        }
        case NotchedCornerPosition.BottomRight: {
            return {
                bottom: 0,
                right: 0,
            };
        }
    }
}
function getNotchedLineProps(size, position) {
    switch (position) {
        case NotchedCornerPosition.TopLeft: {
            return {
                x1: 0,
                y1: size,
                x2: size,
                y2: 0,
            };
        }
        case NotchedCornerPosition.TopRight: {
            return {
                x1: 0,
                y1: 0,
                x2: size,
                y2: size,
            };
        }
        case NotchedCornerPosition.BottomLeft: {
            return {
                x1: 0,
                y1: 0,
                x2: size,
                y2: size,
            };
        }
        case NotchedCornerPosition.BottomRight: {
            return {
                x1: 0,
                y1: size,
                x2: size,
                y2: 0,
            };
        }
    }
}
const NotchedCorner = ({ size, position }) => {
    const { primaryColor } = (0, hooks_1.usePrimaryColor)();
    const positionProps = getNotchedCornerPositionProps(position);
    const polygonPoints = getNotchedPolygonPoints(size, position);
    const lineProps = getNotchedLineProps(size, position);
    return (react_2.default.createElement(react_1.Box, Object.assign({ position: "absolute", height: `${size}px`, width: `${size}px` }, positionProps),
        react_2.default.createElement("svg", { width: size, height: size, viewBox: `0 0 ${size} ${size}`, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_2.default.createElement("polyline", { points: polygonPoints, fill: "black" }),
            react_2.default.createElement("line", Object.assign({ stroke: primaryColor, strokeLinecap: "square" }, lineProps)))));
};
exports.NotchedCorner = NotchedCorner;
//# sourceMappingURL=NotchedCorner.js.map